'use strict';
/*
 * 颜色选择器
 */
var React = require('react');
var GlobalConst = require('../../types/GlobalConst');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var graphicsHelper = require('./../../helper/graphicsHelper');

var ColorPicker = React.createClass({

  componentWillUnmount: function(){
    if(this.requestID){
      cancelAnimationFrame(this.requestID);
    }
  },

  _doPaint: function () {
    var selfDom = ReactDOM.findDOMNode(this.refs.canvas);
    var graphics = selfDom.getContext('2d');
    var clientWidth = selfDom.clientWidth;
    var clientHeight = selfDom.clientHeight;

    //var clientWidth = this.props.w;
    //var clientHeight = this.props.h;

    var _this = this;
    var clipTriangleSize = 8;
    var clipSizeIncrement = 2;

    var fillRect;

    graphics.save();

    this.requestID = window.requestAnimationFrame(function () {

      var ratio = graphicsHelper.applyDeviceRatio(graphics,clientWidth,clientHeight);
      graphicsHelper.clearRect(graphics);
      clientHeight *= ratio;
      clientWidth *= ratio;
      clipTriangleSize *= ratio;
      clipSizeIncrement *= ratio;
      graphics.beginPath();
      graphics.strokeStyle = GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK;
      graphics.strokeWidth = ratio;


      graphics.strokeRect(0, 0, clientWidth, clientHeight);
      graphics.closePath();

      // 绘制底部实心三角形

      graphics.beginPath();
      graphics.moveTo(clientWidth, clientHeight);
      graphics.lineTo(clientWidth - clipTriangleSize, clientHeight);
      graphics.lineTo(clientWidth, clientHeight - clipTriangleSize);
      graphics.lineTo(clientWidth, clientHeight);
      graphics.closePath();
      graphics.fillStyle = GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK;
      graphics.fill();


      graphics.beginPath();
      graphics.moveTo(clipSizeIncrement, clipSizeIncrement);
      graphics.lineTo(clipSizeIncrement, clientHeight - clipSizeIncrement);
      graphics.lineTo(clientWidth - clipSizeIncrement - clipTriangleSize, clientHeight - clipSizeIncrement);
      graphics.lineTo(clientWidth - clipSizeIncrement, clientHeight - clipSizeIncrement - clipTriangleSize);
      graphics.lineTo(clientWidth - clipSizeIncrement, clipSizeIncrement);
      graphics.lineTo(clipSizeIncrement, clipSizeIncrement);
      graphics.closePath();
      graphics.fillStyle = styleHelper.getPropertyValue(_this.props, propConst.COLOR);
      graphics.fill();
    });

  },

  componentDidUpdate: function () {
    this._doPaint();
  },

  componentDidMount: function () {
    this._doPaint();
  },

  render: function () {

    var canvasStyle = {
      width: '100%',
      height: '100%'
    };

    return (<canvas style={canvasStyle}
                    ref='canvas'
                    width={styleHelper.getWidth(this.props)}
                    height={styleHelper.getHeight(this.props)}>
    </canvas>);
  }

});

module.exports = ColorPicker;



// WEBPACK FOOTER //
// ./src/views/Components/ColorPicker.jsx